import Preload from './src/main.js'
export default Preload
